// @flow

import CheckboxWidget from "./checkbox";
import SchemaTableDatePicker from "./schema-table-date-picker";
import HoursAndMinutesSelectWidget from "./hours-and-minutes-select"; //TODO: Remove
import HoursAndMinutesSelectOptimised from "./hours-and-minutes-select-optimised"; //TODO: Remove

import IconButtonWidget from "./icon-button";
import NumberWidget from "./number";
import SecondsAsHoursInput from "./seconds-as-hours-input";
import SelectWidgetSchemaTable from "./select";
import SelectOptimised from "./select-optimised";
import SwitchWidget from "./switch";
import TextWidget from "./text";
import TextArrayWidget from "./text-array";
import TextareaWidgetState from "./textarea";

import CustomAnswerTypeSwitchWidget from "./custom-answer-type-switch";

const defaultWidgets = {
  checkbox: CheckboxWidget,
  "date-picker": SchemaTableDatePicker,
  "hours-and-minutes-select": HoursAndMinutesSelectWidget, //TODO: Remove
  "hours-and-minutes-select-optimised": HoursAndMinutesSelectOptimised, //TODO: Remove
  "icon-button": IconButtonWidget,
  number: NumberWidget,
  "seconds-as-hours-input": SecondsAsHoursInput,
  select: SelectWidgetSchemaTable,
  "select-optimised": SelectOptimised,
  switch: SwitchWidget,
  text: TextWidget,
  "text-array": TextArrayWidget,
  textarea: TextareaWidgetState,
};

const customWidgets = {
  "custom-answer-type-switch": CustomAnswerTypeSwitchWidget,
};

export default {
  ...defaultWidgets,
  ...customWidgets,
};
